<header class="toolbar">
    <nav class="toolbar__actions" aria-label="Actions">
        <button type="button" mat-raised-button class="btn button-fix button-color-fix-purple" (click)="openChangelog()">
            Changelog <mat-icon class="icon-color-fix">history</mat-icon>
        </button>
    </nav>
    <nav class="toolbar__filters" aria-label="Filters">
        <fiscalyear></fiscalyear>
        <oplversion class="opl-version-box" [hidden]="mersyMassReleaseRevokeDto.HierarchyType !== 'OPL'"></oplversion>
        <period [hidden]="mersyMassReleaseRevokeDto.HierarchyType === 'OPL'"
                [selBehaviour]="'MassReleaseRevoke'"
                [relrevokeParamsIn]="mersyMassReleaseRevokeDto"
                (relrevokeParams)="updatePeriods($event)">
        </period>
    </nav>
</header>
<div class="panel-body edituser zoomIn">
    <usermgmtbranch [selBehaviour]="'MassReleaseRevoke'" (relrevokeParams)="updateMgmtDetails($event)"></usermgmtbranch>
    <br />
    <ownergroupfunction [hierarchyType]="this.mersyMassReleaseRevokeDto.HierarchyType"
                        (selectedKPIOwners)="updateKPIOwners($event)"></ownergroupfunction>
</div>




<div class="stickypanel">
    <button mat-raised-button type="submit" (click)="openReleaseRevokdialog('Release')" [disabled]="isButtonDisabled()" class="btn button-fix button-color-fix-orange pull-right">
        Release
    </button>
    <button mat-raised-button type="submit" (click)="openReleaseRevokdialog('Revoke')" [disabled]="isButtonDisabled()" class="btn button-fix button-color-fix-orange pull-right">
        Revoke
    </button>
</div>
